module.exports = __webpack_public_path__ + "img/Phone.5a8a3007.svg";